"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _utils = require("../../utils");

var BlueHttpProvider = /*#__PURE__*/function () {
  function BlueHttpProvider(config) {
    (0, _classCallCheck2.default)(this, BlueHttpProvider);
    this.config = void 0;
    this.name = 'blue-http';
    this.errorCount = 0;
    this.eventQueue = [];
    this.end_retry = false;
    this.flush_period = 1000 * 5;
    this.async = true;

    if (!config.url) {
      throw new Error('No HTTP endpoint supplied the HTTP Provider!');
    }

    this.config = config;
    this.setFlushPeriod(config.flush_period);
    this.setEventTimeout();

    if (config.end_retry && typeof config.end_retry === 'boolean') {
      this.end_retry = config.end_retry;
    } else {
      this.end_retry = false;
    }
  }

  (0, _createClass2.default)(BlueHttpProvider, [{
    key: "setFlushPeriod",
    value: function setFlushPeriod(flushPeriod) {
      if (flushPeriod === undefined || flushPeriod === null || isNaN(flushPeriod)) {
        this.flush_period = 1000 * 5;
      } else {
        this.flush_period = flushPeriod;
      }

      this.async = this.flush_period > 0;
    }
  }, {
    key: "setEventTimeout",
    value: function setEventTimeout() {
      var _this = this;

      if (this.errorCount > 4 && !this.end_retry) {
        console.log('setting timeout to 15 seconds to avoid unnecessary traffic');
        this.setFlushPeriod(15000);
      }

      if (this.async) {
        (0, _setTimeout2.default)(function () {
          return _this.flushQueue();
        }, this.flush_period);
      }
    }
  }, {
    key: "flush",
    value: function flush() {
      var result = this.flushQueue();

      if (result) {
        result.catch(console.error);
      }
    }
  }, {
    key: "track",
    value: function track(event, eventCBQueue) {
      var _context,
          _this2 = this;

      var eventCopy = JSON.parse((0, _stringify.default)(event));
      this.processEvent(eventCopy);
      console.log((0, _concat.default)(_context = "Queuing event \"".concat(eventCopy['event-external-name'], "\" for eventual sending to HTTP end point ")).call(_context, this.config.url, " with data:"), eventCopy);
      eventCBQueue["".concat(event['event-id'], "-http")] = new _promise.default(function (resolve) {
        _this2.eventQueue.push({
          event: eventCopy,
          callback: function callback() {
            resolve();
            delete eventCBQueue["".concat(event['event-id'], "-http")];
          }
        });

        if (!_this2.async) {
          var result = _this2.flushQueue();

          if (result) {
            result.catch(console.error);
          }
        }
      });
    }
  }, {
    key: "processEvent",
    value: function processEvent(event) {
      if (event.metadata) {
        for (var k = 0; k < event.metadata.length; k++) {
          var _context2;

          if ((0, _indexOf.default)(_context2 = event.metadata[k].key).call(_context2, 'ga_') >= 0) {
            delete event.metadata[k];
          }
        }
      }

      delete event.tmpMetaData;
    }
  }, {
    key: "flushQueue",
    value: function flushQueue() {
      var _this3 = this;

      if (this.eventQueue.length === 0) {
        this.setEventTimeout();
        return;
      }

      var localEventQueue = this.eventQueue;
      this.eventQueue = [];
      var eventsToSend = [];

      var _iterator = (0, _createForOfIteratorHelper2.default)(localEventQueue),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var event = _step.value;
          eventsToSend.push(event.event);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return fetch(this.config.url, {
        body: (0, _stringify.default)(eventsToSend),
        headers: (0, _utils.jsonHeaders)(this.config.headers),
        method: 'POST'
      }).then(function () {
        var _context3;

        var _iterator2 = (0, _createForOfIteratorHelper2.default)(localEventQueue),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var event = _step2.value;
            event.callback();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        _this3.errorCount = 0;

        _this3.setFlushPeriod(_this3.config.flush_period);

        console.log((0, _concat.default)(_context3 = "".concat(eventsToSend.length, " events flushed to: ")).call(_context3, _this3.config.url));

        _this3.setEventTimeout();
      }).catch(function (error) {
        var _context4;

        var _iterator3 = (0, _createForOfIteratorHelper2.default)(localEventQueue),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var event = _step3.value;
            event.callback();
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        _this3.errorCount++;
        _this3.eventQueue = (0, _concat.default)(localEventQueue).call(localEventQueue, _this3.eventQueue);
        console.error((0, _concat.default)(_context4 = "Server-side error with POST: ".concat(_this3.config.url, "\n ")).call(_context4, localEventQueue.length, " events failed to send. TRAAC will continue to retry on next tick."));

        if (_this3.errorCount >= 3 && _this3.end_retry) {
          throw new Error("After 3 consecutive errors in sending; ending retry loop. Latest error:\n".concat(error));
        }

        if (!_this3.async) {
          (0, _setTimeout2.default)(function () {
            return _this3.flushQueue();
          }, 2000);
        }

        _this3.setEventTimeout();
      });
    }
  }]);
  return BlueHttpProvider;
}();

exports.default = BlueHttpProvider;
window.BlueHttpAdapter = BlueHttpProvider;
